import { handleApiRequest } from "../../hooks/callApi";

export const getCalenderData = async ({ userId, startDate, endDate }) => {
  const res = await handleApiRequest(
    `/api/calendar/${userId}?start_date=${startDate}&end_date=${endDate}`,
    "get"
  );

  return res;
};

export const createSharedCalendar = async (data) => {
  const res = await handleApiRequest(`/api/shared-calendar`, "post", data);
  return res;
};

export const validateToken = async (token) => {
  const body = {
    token: token,
  };
  const res = await handleApiRequest(
    `/api/shared-calendar/validate`,
    "post",
    body
  );
  return res;
};

export const createReminder = async (data) => {
  const res = await handleApiRequest(`/api/reminder`, "post", data);
  return res;
};

export const getCalendarReminders = async (userId, date) => {
  const res = await handleApiRequest(`/api/reminder/${userId}/${date}`, "get");
  return res;
};

export const deleteReminder = async (reminderId) => {
  const res = await handleApiRequest(`/api/reminder/${reminderId}`, "delete");
  return res;
};

export const getAllUsersDailyUtilization = async (
  startDate,
  endDate,
  isWeekly,
  department,
  designation,
  memberNameFilter,
  projectFilter
) => {
  const res = await handleApiRequest(
    `/api/calendar/get-all-users-daily-utilization?start_date=${startDate}&end_date=${endDate}&isWeekly=${
      isWeekly ? 1 : 0
    }&department_id=${department}&designation=${designation}&user_name=${memberNameFilter}&project_id=${projectFilter}`,
    "get"
  );

  return res;
};
export const getAllDesignationUtilization = async () => {
  const res = await handleApiRequest(
    `/api/calendar/get-designation-utilization`,
    "get"
  );

  return res;
};

// Calendar Events CRUD Operations

/**
 * Create a calendar event
 * @param {Object} data - Event data payload
 * @returns {Promise} API response
 */
export const createCalendarEvent = async (data) => {
  const res = await handleApiRequest(`/api/calendar/events`, "post", data);
  return res;
};

/**
 * Create a calendar task
 * @param {Object} data - Task data payload
 * @returns {Promise} API response
 */
export const createCalendarTask = async (data) => {
  const res = await handleApiRequest(`/api/calendar/events`, "post", data);
  return res;
};

/**
 * Create a calendar reminder
 * @param {Object} data - Reminder data payload
 * @returns {Promise} API response
 */
export const createCalendarReminder = async (data) => {
  const res = await handleApiRequest(`/api/calendar/events`, "post", data);
  return res;
};

/**
 * Update a calendar event
 * @param {Object} data - Updated event data (includes event_id, type, update_on)
 * @returns {Promise} API response
 */
export const updateCalendarEvent = async (data) => {
  const res = await handleApiRequest(`/api/calendar/events`, "put", data);
  return res;
};

/**
 * Get calendar events with optional filters
 * @param {Object} params - Query parameters (startDate, endDate, type, etc.)
 * @returns {Promise} API response
 */
export const getCalendarEvents = async (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.startDate) {
    queryParams.append("start_date", params.startDate);
  }
  if (params.endDate) {
    queryParams.append("end_date", params.endDate);
  }
  if (params.type) {
    queryParams.append("type", params.type);
  }
  if (params.userId) {
    queryParams.append("user_id", params.userId);
  }

  const queryString = queryParams.toString();
  const url = queryString
    ? `/api/calendar/events?${queryString}`
    : `/api/calendar/events`;

  const res = await handleApiRequest(url, "get");
  return res;
};

/**
 * Delete a calendar event
 * @param {Object} data - Delete payload { event_id, type, delete_on }
 * @returns {Promise} API response
 */
export const deleteCalendarEvent = async (data) => {
  const res = await handleApiRequest(`/api/calendar/events`, "delete", data);
  return res;
};
